var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"list-btn flex-center-center",on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(" 查看题目包 ")]),(_vm.open)?_c('AllList',{attrs:{"visible":_vm.open,"exam":_vm.exam},on:{"update:visible":function($event){_vm.open=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }